import styled from "@emotion/styled";
import { ellipsis } from "polished";
import * as React from "react";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { plural } from "utils/string";

interface IProps {
  name: string;
  isDefault: boolean;
  agentsCount: number;
}

export const TeamProfile: React.FC<IProps> = ({ name, isDefault, agentsCount }) => (
  <TeamDetailsWrapper>
    <TeamName>
      {name}
      {isDefault && <DefaultTeamSpan>(Default team)</DefaultTeamSpan>}
    </TeamName>
    <AgentCount size="xs">
      {agentsCount} {plural(agentsCount, "agent", "agents")}
    </AgentCount>
  </TeamDetailsWrapper>
);

const TeamDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TeamName = styled(Text)`
  color: var(${DesignToken.ContentBasicPrimary});
  ${ellipsis()}
`;

const DefaultTeamSpan = styled.span`
  color: var(${DesignToken.ContentBasicDisabled});
  margin-left: var(${SpacingToken.Spacing1});
`;

const AgentCount = styled(Text)`
  color: var(${DesignToken.ContentBasicSecondary});
`;
